import { state } from '../state'

/**
 * Toggle the visibility of a dropdown menu
 * @param {string} menuId - The ID of the menu to toggle
 */
export const toggleMenu = (menuId) => {
  if (state.openMenu.value === menuId) {
    state.openMenu.value = null
  } else {
    state.openMenu.value = menuId
  }
}

/**
 * Check if a specific menu is open
 * @param {string} menuId - The ID of the menu to check
 * @returns {boolean} - True if the menu is open
 */
export const isMenuOpen = (menuId) => {
  return state.openMenu.value === menuId
}

/**
 * Close all open menus
 */
export const closeAllMenus = () => {
  state.openMenu.value = null
}

/**
 * Handle click outside to close menus
 * @param {Event} event - The click event
 */
export const handleClickOutside = (event) => {
  // If clicked element is not inside a filter menu container, close all menus
  if (!event.target.closest('.filter-menu-container')) {
    closeAllMenus()
  }
}
